var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.592 2.914a13.333 13.333 0 1114.815 22.173A13.333 13.333 0 016.592 2.914zm7.407 4.42a1.333 1.333 0 00-1.333 1.333V14a1.333 1.333 0 002.667 0V8.667a1.334 1.334 0 00-1.334-1.334zm1.227 11.493a1.011 1.011 0 00-.12-.24l-.16-.2a1.333 1.333 0 00-1.453-.28c-.162.067-.31.162-.44.28a1.334 1.334 0 00-.387.946c.002.175.038.347.107.507a1.2 1.2 0 00.72.72 1.254 1.254 0 001.013 0 1.2 1.2 0 00.72-.72c.068-.16.105-.332.107-.507a1.826 1.826 0 000-.266.854.854 0 00-.107-.24z",
    fill: "#FB8700"
  })));
}
export default SvgWarningFilled;